module.exports = __webpack_public_path__ + "images/thomas-brooke.bc8c71d888f30303705d204a013abcf8.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/thomas-brooke.jpeg
// module id = 1030
// module chunks = 0